export const IS_AT_BOTTOM_OFFSET = 10; // in pixels, offset to consider the chat is at the bottom
export const AGENT_RESPONSE_TIMEOUT = 20000; // in miliseconds
// A cold agent worker can take longer than five seconds to join. Replacing the
// room too early abandons the dispatch while the microphone is publishing and
// leaves LiveKit's engine disconnected.
export const AGENT_CONNECTION_TIMEOUT = 30000; // in milliseconds
export const CHAT_WINDOW_MAX_HEIGHT = 792;
export const CHAT_WINDOW_TOP_MARGIN = 40;
